import React from 'react';
import cx from 'classnames';
import { Tabs } from 'new/elements/Tabs';
import {
  ActivityTab,
  ErrorDataTab,
  OverviewTab,
  RootTab,
  RulesTab,
  ShareTab,
  StatsTab,
} from 'new/components/marketplace/components/DataProductsDrawer/components/Tabs';
import { useSharedDatasetTabs } from 'new/components/marketplace/components/DataProductsDrawer/components/SharedDatasetDetailsTabs/hooks/useDatasetTabs';
import type { SharedDatasetDetailsTabsProps } from 'new/components/marketplace/components/DataProductsDrawer/components/SharedDatasetDetailsTabs/types';

import styles from './SharedDatasetDetailsTabs.module.scss';

export const SharedDatasetDetailsTabs = (props: SharedDatasetDetailsTabsProps) => {
  const { dataset, onTabChange, initialTab = 'overview' } = props;

  const { activeTab, tabs, handleTabChange } = useSharedDatasetTabs(
    dataset,
    initialTab,
    onTabChange,
  );

  if (!dataset) return null;

  return (
    <div className={cx(styles.sharedDatasetDetailsTabsContainer, props?.className)}>
      <div className={styles.tabsContainer}>
        <Tabs tabs={tabs} value={activeTab} onChange={handleTabChange} />
      </div>

      <RootTab value="overview" activeTab={activeTab} keepMountedAfterActivation>
        <OverviewTab dataset={dataset} />
      </RootTab>

      <RootTab value="rules" activeTab={activeTab} keepMountedAfterActivation>
        <RulesTab dataset={dataset} />
      </RootTab>

      <RootTab value="stats" activeTab={activeTab}>
        <StatsTab dataset={dataset} />
      </RootTab>

      <RootTab value="activity" activeTab={activeTab}>
        <ActivityTab dataset={dataset} />
      </RootTab>

      <RootTab value="errorData" activeTab={activeTab}>
        <ErrorDataTab dataset={dataset} />
      </RootTab>

      <RootTab value="share" activeTab={activeTab} keepMountedAfterActivation>
        <ShareTab dataset={dataset} />
      </RootTab>
    </div>
  );
};
